import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';
import { map, mapTo } from 'rxjs/operators';
import * as i1 from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var GetSnapshotWidgetConfigResponseStatus = /*#__PURE__*/function (GetSnapshotWidgetConfigResponseStatus) {
  GetSnapshotWidgetConfigResponseStatus[GetSnapshotWidgetConfigResponseStatus["ENABLED"] = 0] = "ENABLED";
  GetSnapshotWidgetConfigResponseStatus[GetSnapshotWidgetConfigResponseStatus["DISABLED"] = 1] = "DISABLED";
  GetSnapshotWidgetConfigResponseStatus[GetSnapshotWidgetConfigResponseStatus["RATE_LIMITED"] = 2] = "RATE_LIMITED";
  return GetSnapshotWidgetConfigResponseStatus;
}(GetSnapshotWidgetConfigResponseStatus || {});
// *********************************

function enumStringToValue(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Activation {
  static fromProto(proto) {
    let m = new Activation();
    m = Object.assign(m, proto);
    if (proto.appKey) {
      m.appKey = AppKey.fromProto(proto.appKey);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appKey !== 'undefined' && this.appKey !== null) {
      toReturn['appKey'] = 'toApiJson' in this.appKey ? this.appKey.toApiJson() : this.appKey;
    }
    if (typeof this.isTrial !== 'undefined') {
      toReturn['isTrial'] = this.isTrial;
    }
    return toReturn;
  }
}
class AppKey {
  static fromProto(proto) {
    let m = new AppKey();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.editionId !== 'undefined') {
      toReturn['editionId'] = this.editionId;
    }
    return toReturn;
  }
}
class AutocompletePrediction {
  static fromProto(proto) {
    let m = new AutocompletePrediction();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    if (typeof this.placeId !== 'undefined') {
      toReturn['placeId'] = this.placeId;
    }
    if (typeof this.mainText !== 'undefined') {
      toReturn['mainText'] = this.mainText;
    }
    if (typeof this.secondaryText !== 'undefined') {
      toReturn['secondaryText'] = this.secondaryText;
    }
    return toReturn;
  }
}
class CreateSnapshotFromPlaceIDRequest {
  static fromProto(proto) {
    let m = new CreateSnapshotFromPlaceIDRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.widgetId !== 'undefined') {
      toReturn['widgetId'] = this.widgetId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.placeId !== 'undefined') {
      toReturn['placeId'] = this.placeId;
    }
    if (typeof this.contactFirstName !== 'undefined') {
      toReturn['contactFirstName'] = this.contactFirstName;
    }
    if (typeof this.contactEmail !== 'undefined') {
      toReturn['contactEmail'] = this.contactEmail;
    }
    if (typeof this.dataProtectionPolicy !== 'undefined') {
      toReturn['dataProtectionPolicy'] = this.dataProtectionPolicy;
    }
    if (typeof this.emailNotificationAgreement !== 'undefined') {
      toReturn['emailNotificationAgreement'] = this.emailNotificationAgreement;
    }
    return toReturn;
  }
}
class CreateSnapshotRequest {
  static fromProto(proto) {
    let m = new CreateSnapshotRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.widgetId !== 'undefined') {
      toReturn['widgetId'] = this.widgetId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.contactFirstName !== 'undefined') {
      toReturn['contactFirstName'] = this.contactFirstName;
    }
    if (typeof this.contactLastName !== 'undefined') {
      toReturn['contactLastName'] = this.contactLastName;
    }
    if (typeof this.contactEmail !== 'undefined') {
      toReturn['contactEmail'] = this.contactEmail;
    }
    if (typeof this.businessName !== 'undefined') {
      toReturn['businessName'] = this.businessName;
    }
    if (typeof this.website !== 'undefined') {
      toReturn['website'] = this.website;
    }
    if (typeof this.streetAddress !== 'undefined') {
      toReturn['streetAddress'] = this.streetAddress;
    }
    if (typeof this.city !== 'undefined') {
      toReturn['city'] = this.city;
    }
    if (typeof this.state !== 'undefined') {
      toReturn['state'] = this.state;
    }
    if (typeof this.zip !== 'undefined') {
      toReturn['zip'] = this.zip;
    }
    if (typeof this.country !== 'undefined') {
      toReturn['country'] = this.country;
    }
    if (typeof this.businessCategory !== 'undefined') {
      toReturn['businessCategory'] = this.businessCategory;
    }
    if (typeof this.phone !== 'undefined') {
      toReturn['phone'] = this.phone;
    }
    if (typeof this.facebookUrl !== 'undefined') {
      toReturn['facebookUrl'] = this.facebookUrl;
    }
    if (typeof this.twitterUrl !== 'undefined') {
      toReturn['twitterUrl'] = this.twitterUrl;
    }
    if (typeof this.instagramUrl !== 'undefined') {
      toReturn['instagramUrl'] = this.instagramUrl;
    }
    if (typeof this.dataProtectionPolicy !== 'undefined') {
      toReturn['dataProtectionPolicy'] = this.dataProtectionPolicy;
    }
    if (typeof this.emailNotificationAgreement !== 'undefined') {
      toReturn['emailNotificationAgreement'] = this.emailNotificationAgreement;
    }
    return toReturn;
  }
}
class CreateSnapshotWidgetRequest {
  static fromProto(proto) {
    let m = new CreateSnapshotWidgetRequest();
    m = Object.assign(m, proto);
    if (proto.includedProducts) {
      m.includedProducts = proto.includedProducts.map(Activation.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.campaignId !== 'undefined') {
      toReturn['campaignId'] = this.campaignId;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.salespersonIds !== 'undefined') {
      toReturn['salespersonIds'] = this.salespersonIds;
    }
    if (typeof this.disabled !== 'undefined') {
      toReturn['disabled'] = this.disabled;
    }
    if (typeof this.landingPageUrl !== 'undefined') {
      toReturn['landingPageUrl'] = this.landingPageUrl;
    }
    if (typeof this.includedProducts !== 'undefined' && this.includedProducts !== null) {
      toReturn['includedProducts'] = 'toApiJson' in this.includedProducts ? this.includedProducts.toApiJson() : this.includedProducts;
    }
    if (typeof this.dontGenerateSnapshot !== 'undefined') {
      toReturn['dontGenerateSnapshot'] = this.dontGenerateSnapshot;
    }
    if (typeof this.addTags !== 'undefined') {
      toReturn['addTags'] = this.addTags;
    }
    return toReturn;
  }
}
class CreateSnapshotWidgetResponse {
  static fromProto(proto) {
    let m = new CreateSnapshotWidgetResponse();
    m = Object.assign(m, proto);
    if (proto.snapshotWidget) {
      m.snapshotWidget = SnapshotWidget.fromProto(proto.snapshotWidget);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.snapshotWidget !== 'undefined' && this.snapshotWidget !== null) {
      toReturn['snapshotWidget'] = 'toApiJson' in this.snapshotWidget ? this.snapshotWidget.toApiJson() : this.snapshotWidget;
    }
    return toReturn;
  }
}
class DeleteSnapshotWidgetRequest {
  static fromProto(proto) {
    let m = new DeleteSnapshotWidgetRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.widgetId !== 'undefined') {
      toReturn['widgetId'] = this.widgetId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    return toReturn;
  }
}
class ListSnapshotWidgetRequestFilters {
  static fromProto(proto) {
    let m = new ListSnapshotWidgetRequestFilters();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    return toReturn;
  }
}
class GetEmbedCodeRequest {
  static fromProto(proto) {
    let m = new GetEmbedCodeRequest();
    m = Object.assign(m, proto);
    if (proto.styles) {
      m.styles = WidgetStyles.fromProto(proto.styles);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.widgetId !== 'undefined') {
      toReturn['widgetId'] = this.widgetId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.styles !== 'undefined' && this.styles !== null) {
      toReturn['styles'] = 'toApiJson' in this.styles ? this.styles.toApiJson() : this.styles;
    }
    return toReturn;
  }
}
class GetEmbedCodeResponse {
  static fromProto(proto) {
    let m = new GetEmbedCodeResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.embedCode !== 'undefined') {
      toReturn['embedCode'] = this.embedCode;
    }
    return toReturn;
  }
}
class GetSnapshotWidgetConfigRequest {
  static fromProto(proto) {
    let m = new GetSnapshotWidgetConfigRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.widgetId !== 'undefined') {
      toReturn['widgetId'] = this.widgetId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    return toReturn;
  }
}
class GetSnapshotWidgetConfigResponse {
  static fromProto(proto) {
    let m = new GetSnapshotWidgetConfigResponse();
    m = Object.assign(m, proto);
    if (proto.styles) {
      m.styles = WidgetStyles.fromProto(proto.styles);
    }
    if (proto.status) {
      m.status = enumStringToValue(GetSnapshotWidgetConfigResponseStatus, proto.status);
    }
    if (proto.includedProducts) {
      m.includedProducts = proto.includedProducts.map(Activation.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.styles !== 'undefined' && this.styles !== null) {
      toReturn['styles'] = 'toApiJson' in this.styles ? this.styles.toApiJson() : this.styles;
    }
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.landingPageUrl !== 'undefined') {
      toReturn['landingPageUrl'] = this.landingPageUrl;
    }
    if (typeof this.includedProducts !== 'undefined' && this.includedProducts !== null) {
      toReturn['includedProducts'] = 'toApiJson' in this.includedProducts ? this.includedProducts.toApiJson() : this.includedProducts;
    }
    if (typeof this.dontGenerateSnapshot !== 'undefined') {
      toReturn['dontGenerateSnapshot'] = this.dontGenerateSnapshot;
    }
    if (typeof this.addTags !== 'undefined') {
      toReturn['addTags'] = this.addTags;
    }
    return toReturn;
  }
}
class GetSnapshotWidgetRequest {
  static fromProto(proto) {
    let m = new GetSnapshotWidgetRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.widgetId !== 'undefined') {
      toReturn['widgetId'] = this.widgetId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    return toReturn;
  }
}
class GetSnapshotWidgetResponse {
  static fromProto(proto) {
    let m = new GetSnapshotWidgetResponse();
    m = Object.assign(m, proto);
    if (proto.snapshotWidget) {
      m.snapshotWidget = SnapshotWidget.fromProto(proto.snapshotWidget);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.snapshotWidget !== 'undefined' && this.snapshotWidget !== null) {
      toReturn['snapshotWidget'] = 'toApiJson' in this.snapshotWidget ? this.snapshotWidget.toApiJson() : this.snapshotWidget;
    }
    return toReturn;
  }
}
class ListSnapshotWidgetRequest {
  static fromProto(proto) {
    let m = new ListSnapshotWidgetRequest();
    m = Object.assign(m, proto);
    if (proto.filters) {
      m.filters = ListSnapshotWidgetRequestFilters.fromProto(proto.filters);
    }
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    return toReturn;
  }
}
class ListSnapshotWidgetResponse {
  static fromProto(proto) {
    let m = new ListSnapshotWidgetResponse();
    m = Object.assign(m, proto);
    if (proto.snapshotWidgets) {
      m.snapshotWidgets = proto.snapshotWidgets.map(SnapshotWidget.fromProto);
    }
    if (proto.totalResults) {
      m.totalResults = parseInt(proto.totalResults, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.snapshotWidgets !== 'undefined' && this.snapshotWidgets !== null) {
      toReturn['snapshotWidgets'] = 'toApiJson' in this.snapshotWidgets ? this.snapshotWidgets.toApiJson() : this.snapshotWidgets;
    }
    if (typeof this.nextCursor !== 'undefined') {
      toReturn['nextCursor'] = this.nextCursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    if (typeof this.totalResults !== 'undefined') {
      toReturn['totalResults'] = this.totalResults;
    }
    return toReturn;
  }
}
class Location {
  static fromProto(proto) {
    let m = new Location();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.latitude !== 'undefined') {
      toReturn['latitude'] = this.latitude;
    }
    if (typeof this.longitude !== 'undefined') {
      toReturn['longitude'] = this.longitude;
    }
    return toReturn;
  }
}
class SnapshotAutocompleteRequest {
  static fromProto(proto) {
    let m = new SnapshotAutocompleteRequest();
    m = Object.assign(m, proto);
    if (proto.location) {
      m.location = Location.fromProto(proto.location);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.widgetId !== 'undefined') {
      toReturn['widgetId'] = this.widgetId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.searchTerm !== 'undefined') {
      toReturn['searchTerm'] = this.searchTerm;
    }
    if (typeof this.location !== 'undefined' && this.location !== null) {
      toReturn['location'] = 'toApiJson' in this.location ? this.location.toApiJson() : this.location;
    }
    return toReturn;
  }
}
class SnapshotAutocompleteResponse {
  static fromProto(proto) {
    let m = new SnapshotAutocompleteResponse();
    m = Object.assign(m, proto);
    if (proto.predictions) {
      m.predictions = proto.predictions.map(AutocompletePrediction.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.predictions !== 'undefined' && this.predictions !== null) {
      toReturn['predictions'] = 'toApiJson' in this.predictions ? this.predictions.toApiJson() : this.predictions;
    }
    return toReturn;
  }
}
class SnapshotWidget {
  static fromProto(proto) {
    let m = new SnapshotWidget();
    m = Object.assign(m, proto);
    if (proto.styles) {
      m.styles = WidgetStyles.fromProto(proto.styles);
    }
    if (proto.deleted) {
      m.deleted = new Date(proto.deleted);
    }
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    if (proto.accountsCreated) {
      m.accountsCreated = parseInt(proto.accountsCreated, 10);
    }
    if (proto.includedProducts) {
      m.includedProducts = proto.includedProducts.map(Activation.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.widgetId !== 'undefined') {
      toReturn['widgetId'] = this.widgetId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.campaignId !== 'undefined') {
      toReturn['campaignId'] = this.campaignId;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.salespersonIds !== 'undefined') {
      toReturn['salespersonIds'] = this.salespersonIds;
    }
    if (typeof this.apiKey !== 'undefined') {
      toReturn['apiKey'] = this.apiKey;
    }
    if (typeof this.styles !== 'undefined' && this.styles !== null) {
      toReturn['styles'] = 'toApiJson' in this.styles ? this.styles.toApiJson() : this.styles;
    }
    if (typeof this.deleted !== 'undefined' && this.deleted !== null) {
      toReturn['deleted'] = 'toApiJson' in this.deleted ? this.deleted.toApiJson() : this.deleted;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    if (typeof this.accountsCreated !== 'undefined') {
      toReturn['accountsCreated'] = this.accountsCreated;
    }
    if (typeof this.disabled !== 'undefined') {
      toReturn['disabled'] = this.disabled;
    }
    if (typeof this.landingPageUrl !== 'undefined') {
      toReturn['landingPageUrl'] = this.landingPageUrl;
    }
    if (typeof this.includedProducts !== 'undefined' && this.includedProducts !== null) {
      toReturn['includedProducts'] = 'toApiJson' in this.includedProducts ? this.includedProducts.toApiJson() : this.includedProducts;
    }
    if (typeof this.dontGenerateSnapshot !== 'undefined') {
      toReturn['dontGenerateSnapshot'] = this.dontGenerateSnapshot;
    }
    if (typeof this.addTags !== 'undefined') {
      toReturn['addTags'] = this.addTags;
    }
    return toReturn;
  }
}
class UpdateSnapshotWidgetRequest {
  static fromProto(proto) {
    let m = new UpdateSnapshotWidgetRequest();
    m = Object.assign(m, proto);
    if (proto.styles) {
      m.styles = WidgetStyles.fromProto(proto.styles);
    }
    if (proto.includedProducts) {
      m.includedProducts = proto.includedProducts.map(Activation.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.widgetId !== 'undefined') {
      toReturn['widgetId'] = this.widgetId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.campaignId !== 'undefined') {
      toReturn['campaignId'] = this.campaignId;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.salespersonIds !== 'undefined') {
      toReturn['salespersonIds'] = this.salespersonIds;
    }
    if (typeof this.styles !== 'undefined' && this.styles !== null) {
      toReturn['styles'] = 'toApiJson' in this.styles ? this.styles.toApiJson() : this.styles;
    }
    if (typeof this.disabled !== 'undefined') {
      toReturn['disabled'] = this.disabled;
    }
    if (typeof this.landingPageUrl !== 'undefined') {
      toReturn['landingPageUrl'] = this.landingPageUrl;
    }
    if (typeof this.includedProducts !== 'undefined' && this.includedProducts !== null) {
      toReturn['includedProducts'] = 'toApiJson' in this.includedProducts ? this.includedProducts.toApiJson() : this.includedProducts;
    }
    if (typeof this.dontGenerateSnapshot !== 'undefined') {
      toReturn['dontGenerateSnapshot'] = this.dontGenerateSnapshot;
    }
    if (typeof this.addTags !== 'undefined') {
      toReturn['addTags'] = this.addTags;
    }
    return toReturn;
  }
}
class UpdateStylesRequest {
  static fromProto(proto) {
    let m = new UpdateStylesRequest();
    m = Object.assign(m, proto);
    if (proto.styles) {
      m.styles = WidgetStyles.fromProto(proto.styles);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.widgetId !== 'undefined') {
      toReturn['widgetId'] = this.widgetId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.styles !== 'undefined' && this.styles !== null) {
      toReturn['styles'] = 'toApiJson' in this.styles ? this.styles.toApiJson() : this.styles;
    }
    return toReturn;
  }
}
class WidgetStyles {
  static fromProto(proto) {
    let m = new WidgetStyles();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.width !== 'undefined') {
      toReturn['width'] = this.width;
    }
    if (typeof this.backgroundColor !== 'undefined') {
      toReturn['backgroundColor'] = this.backgroundColor;
    }
    if (typeof this.borderColor !== 'undefined') {
      toReturn['borderColor'] = this.borderColor;
    }
    if (typeof this.borderRadius !== 'undefined') {
      toReturn['borderRadius'] = this.borderRadius;
    }
    if (typeof this.dropShadow !== 'undefined') {
      toReturn['dropShadow'] = this.dropShadow;
    }
    if (typeof this.primaryFontColor !== 'undefined') {
      toReturn['primaryFontColor'] = this.primaryFontColor;
    }
    if (typeof this.secondaryFontColor !== 'undefined') {
      toReturn['secondaryFontColor'] = this.secondaryFontColor;
    }
    if (typeof this.buttonColor !== 'undefined') {
      toReturn['buttonColor'] = this.buttonColor;
    }
    if (typeof this.buttonFontColor !== 'undefined') {
      toReturn['buttonFontColor'] = this.buttonFontColor;
    }
    if (typeof this.titleText !== 'undefined') {
      toReturn['titleText'] = this.titleText;
    }
    if (typeof this.buttonText !== 'undefined') {
      toReturn['buttonText'] = this.buttonText;
    }
    if (typeof this.confirmationTitleText !== 'undefined') {
      toReturn['confirmationTitleText'] = this.confirmationTitleText;
    }
    if (typeof this.confirmationBodyText !== 'undefined') {
      toReturn['confirmationBodyText'] = this.confirmationBodyText;
    }
    if (typeof this.dataProtectionPolicyText !== 'undefined') {
      toReturn['dataProtectionPolicyText'] = this.dataProtectionPolicyText;
    }
    if (typeof this.emailNotificationAgreementText !== 'undefined') {
      toReturn['emailNotificationAgreementText'] = this.emailNotificationAgreementText;
    }
    if (typeof this.consentInformationText !== 'undefined') {
      toReturn['consentInformationText'] = this.consentInformationText;
    }
    return toReturn;
  }
}

// *********************************

const environment = (window ? window['environment'] : 'prod') ?? 'prod';
const hostMap = {
  'local': 'snapshot-widget-api.vendasta-local.com',
  'test': '',
  'demo': 'snapshot-widget-demo.apigateway.co',
  'prod': 'widget.snapshotreport.biz',
  'production': 'widget.snapshotreport.biz'
};
let HostService = /*#__PURE__*/(() => {
  class HostService {
    get host() {
      return hostMap[environment.toLowerCase()];
    }
    get hostWithScheme() {
      return 'https://' + this.host;
    }
  }
  HostService.ɵfac = function HostService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || HostService)();
  };
  HostService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: HostService,
    factory: HostService.ɵfac,
    providedIn: 'root'
  });
  return HostService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let SnapshotWidgetApiService = /*#__PURE__*/(() => {
  class SnapshotWidgetApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    create(r) {
      const request = r.toApiJson ? r : new CreateSnapshotWidgetRequest(r);
      return this.http.post(this._host + "/snapshotwidget.v1.SnapshotWidgetService/Create", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateSnapshotWidgetResponse.fromProto(resp)));
    }
    get(r) {
      const request = r.toApiJson ? r : new GetSnapshotWidgetRequest(r);
      return this.http.post(this._host + "/snapshotwidget.v1.SnapshotWidgetService/Get", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetSnapshotWidgetResponse.fromProto(resp)));
    }
    update(r) {
      const request = r.toApiJson ? r : new UpdateSnapshotWidgetRequest(r);
      return this.http.post(this._host + "/snapshotwidget.v1.SnapshotWidgetService/Update", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    delete(r) {
      const request = r.toApiJson ? r : new DeleteSnapshotWidgetRequest(r);
      return this.http.post(this._host + "/snapshotwidget.v1.SnapshotWidgetService/Delete", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    list(r) {
      const request = r.toApiJson ? r : new ListSnapshotWidgetRequest(r);
      return this.http.post(this._host + "/snapshotwidget.v1.SnapshotWidgetService/List", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListSnapshotWidgetResponse.fromProto(resp)));
    }
    updateStyles(r) {
      const request = r.toApiJson ? r : new UpdateStylesRequest(r);
      return this.http.post(this._host + "/snapshotwidget.v1.SnapshotWidgetService/UpdateStyles", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getEmbedCode(r) {
      const request = r.toApiJson ? r : new GetEmbedCodeRequest(r);
      return this.http.post(this._host + "/snapshotwidget.v1.SnapshotWidgetService/GetEmbedCode", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetEmbedCodeResponse.fromProto(resp)));
    }
    snapshotAutocomplete(r) {
      const request = r.toApiJson ? r : new SnapshotAutocompleteRequest(r);
      return this.http.post(this._host + "/snapshotwidget.v1.SnapshotWidgetService/SnapshotAutocomplete", request.toApiJson(), this.apiOptions()).pipe(map(resp => SnapshotAutocompleteResponse.fromProto(resp)));
    }
    createSnapshotFromPlaceId(r) {
      const request = r.toApiJson ? r : new CreateSnapshotFromPlaceIDRequest(r);
      return this.http.post(this._host + "/snapshotwidget.v1.SnapshotWidgetService/CreateSnapshotFromPlaceID", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    createSnapshot(r) {
      const request = r.toApiJson ? r : new CreateSnapshotRequest(r);
      return this.http.post(this._host + "/snapshotwidget.v1.SnapshotWidgetService/CreateSnapshot", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getSnapshotWidgetConfig(r) {
      const request = r.toApiJson ? r : new GetSnapshotWidgetConfigRequest(r);
      return this.http.post(this._host + "/snapshotwidget.v1.SnapshotWidgetService/GetSnapshotWidgetConfig", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetSnapshotWidgetConfigResponse.fromProto(resp)));
    }
  }
  SnapshotWidgetApiService.ɵfac = function SnapshotWidgetApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || SnapshotWidgetApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  SnapshotWidgetApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: SnapshotWidgetApiService,
    factory: SnapshotWidgetApiService.ɵfac,
    providedIn: 'root'
  });
  return SnapshotWidgetApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class PagedResponse {
  constructor(results, nextCursor, hasMore, totalResults) {
    this.results = results;
    this.nextCursor = nextCursor;
    this.hasMore = hasMore;
    this.totalResults = totalResults;
  }
}
let SnapshotWidgetService = /*#__PURE__*/(() => {
  class SnapshotWidgetService {
    constructor(api) {
      this.api = api;
    }
    create(snapshot) {
      return this.api.create(snapshot).pipe(map(response => response.snapshotWidget));
    }
    get(widgetId, partnerId) {
      return this.api.get({
        widgetId: widgetId,
        partnerId: partnerId
      }).pipe(map(response => response.snapshotWidget));
    }
    update(snapshotWidget) {
      return this.api.update({
        widgetId: snapshotWidget.widgetId,
        partnerId: snapshotWidget.partnerId,
        marketId: snapshotWidget.marketId,
        campaignId: snapshotWidget.campaignId,
        name: snapshotWidget.name,
        salespersonIds: snapshotWidget.salespersonIds,
        styles: snapshotWidget.styles,
        disabled: snapshotWidget.disabled,
        landingPageUrl: snapshotWidget.landingPageUrl,
        includedProducts: snapshotWidget.includedProducts,
        dontGenerateSnapshot: snapshotWidget.dontGenerateSnapshot,
        addTags: snapshotWidget.addTags
      }).pipe(map(_ => true));
    }
    delete(widgetId, partnerId) {
      return this.api.delete({
        widgetId: widgetId,
        partnerId: partnerId
      }).pipe(map(_ => true));
    }
    list(filters, cursor, pageSize) {
      return this.api.list({
        filters,
        cursor,
        pageSize
      }).pipe(map(resp => {
        const results = resp.totalResults || 0;
        return new PagedResponse(resp.snapshotWidgets, resp.nextCursor, resp.hasMore, results);
      }));
    }
    updateStyles(widgetId, partnerId, styles) {
      return this.api.updateStyles({
        widgetId,
        partnerId,
        styles
      }).pipe(mapTo(true));
    }
    getEmbedCode(widgetId, partnerId, styles) {
      return this.api.getEmbedCode({
        widgetId,
        partnerId,
        styles
      }).pipe(map(resp => resp.embedCode));
    }
    snapshotAutocomplete(widgetId, partnerId, searchTerm, location) {
      return this.api.snapshotAutocomplete({
        widgetId,
        partnerId,
        searchTerm,
        location
      }).pipe(map(resp => resp.predictions));
    }
    createSnapshotFromPlaceId(widgetId, partnerId, placeId, contactFirstName, contactEmail) {
      return this.api.createSnapshotFromPlaceId({
        widgetId,
        partnerId,
        placeId,
        contactFirstName,
        contactEmail
      }).pipe(mapTo(true));
    }
    createSnapshot(snapshot) {
      return this.api.createSnapshot(snapshot).pipe(mapTo(true));
    }
    getSnapshotWidgetConfig(widgetId, partnerId) {
      return this.api.getSnapshotWidgetConfig({
        widgetId,
        partnerId
      });
    }
  }
  SnapshotWidgetService.ɵfac = function SnapshotWidgetService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || SnapshotWidgetService)(i0.ɵɵinject(SnapshotWidgetApiService));
  };
  SnapshotWidgetService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: SnapshotWidgetService,
    factory: SnapshotWidgetService.ɵfac,
    providedIn: 'root'
  });
  return SnapshotWidgetService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************

/**
 * Generated bundle index. Do not edit.
 */

export { Activation, GetSnapshotWidgetConfigResponseStatus, Location, PagedResponse, SnapshotAutocompleteRequest, SnapshotAutocompleteResponse, SnapshotWidget, SnapshotWidgetService, UpdateSnapshotWidgetRequest, UpdateStylesRequest, WidgetStyles };
